import React from 'react';

export const SlideContext = React.createContext();

export const useSlideContext = () => React.useContext(SlideContext);
